'use client'

import { GoogleAnalytics } from '@next/third-parties/google'

import { FacebookPixel } from '../next/analytics'

const Analytics = () => (
  <>
    <FacebookPixel />
    <GoogleAnalytics gaId={process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID ?? ''} />
  </>
)

export { Analytics as default }
